import { render, staticRenderFns } from "./PropertiesPanel.vue?vue&type=template&id=33632757"
import script from "./PropertiesPanel.vue?vue&type=script&lang=js"
export * from "./PropertiesPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertiesPanel.vue?vue&type=style&index=0&id=33632757&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports